import { useState } from 'react';
import { faqs } from '@/mocks/faqs';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-20 md:py-28 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-14">
            <span className="inline-block px-4 py-1.5 bg-secondary-100 text-secondary-700 text-xs font-medium rounded-full mb-4">
              常见问题
            </span>
            <h2 className="text-2xl md:text-4xl font-heading font-semibold text-foreground-950 mb-4">
              您可能想了解的
            </h2>
            <p className="text-sm text-foreground-600">
              快速找到关于凪光在线最常见问题的答案
            </p>
          </div>

          <div className="space-y-3">
            {faqs.slice(0, 6).map((faq, index) => (
              <div
                key={index}
                className="bg-background-50 border border-background-200/70 rounded-xl overflow-hidden transition-all duration-300"
              >
                <button
                  className="w-full flex items-center justify-between px-6 py-4 text-left cursor-pointer"
                  onClick={() => toggleFAQ(index)}
                >
                  <span className="text-sm font-medium text-foreground-900 pr-4">{faq.question}</span>
                  <span className={`flex-shrink-0 w-6 h-6 rounded-full flex items-center justify-center transition-all duration-300 ${openIndex === index ? 'bg-primary-500 text-background-50 rotate-45' : 'bg-background-200 text-foreground-500'}`}>
                    <i className="ri-add-line text-sm"></i>
                  </span>
                </button>
                <div
                  className={`overflow-hidden transition-all duration-300 ${
                    openIndex === index ? 'max-h-96 pb-4' : 'max-h-0'
                  }`}
                >
                  <p className="text-sm text-foreground-600 leading-relaxed px-6">{faq.answer}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}